export default "__VITE_ASSET__Du1v92w7__"